import { gql } from '@apollo/client';
import { query } from '../../Services/Gateway/Apollo';

const GET_AUTOCOMPLETE_OPTIONS = gql`
  query GetAutoCompleteOptions(
    $answerQuery: String!
    $webformId: Int!
    $componentId: Int!
  ) {
    getAutoCompleteOptions(
      answerQuery: $answerQuery
      webformId: $webformId
      componentId: $componentId
    ) {
      label
    }
  }
`;

const getAutoCompleteOptions = async (params) => {
  const { variables } = params;
  try {
    const options = await query({
      query: GET_AUTOCOMPLETE_OPTIONS,
      variables,
    });

    return options.data.getAutoCompleteOptions;
  } catch (error) {
    throw new Error(error);
  }
};

export default getAutoCompleteOptions;
